(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-aw-compatibility-analytics-bridge]';
  const STATE_SELECTOR = '[data-aw-compatibility-analytics-state]';

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

  const isSafeLanding = (path) =>
    typeof path === 'string' &&
    /^\/pages\/compatibilite-airsoft-[a-z0-9-]+$/i.test(path);

  const parseState = () => {
    const node = document.querySelector(STATE_SELECTOR);
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('[AW Compatibility P2] Analytics state JSON is invalid.', error);
      return null;
    }
  };

  const getIntent = () => {
    const params = new URLSearchParams(window.location.search);
    return normalize(params.get('aw_intent') || params.get('intent') || 'all');
  };

  const getQuery = () => {
    const params = new URLSearchParams(window.location.search);
    return String(params.get('q') || '').trim();
  };

  const buildCandidates = (state) => {
    const visibility = Array.isArray(state?.search_visibility_queue)
      ? state.search_visibility_queue
          .filter((item) =>
            item &&
            item.platform &&
            isSafeLanding(item.landing_path) &&
            (
              item.class === 'visibilite_recherche' ||
              String(item.action || '').includes('routing')
            )
          )
          .map((item) => ({ ...item, queue: 'visibility' }))
      : [];

    const disambiguation = Array.isArray(state?.disambiguation_queue)
      ? state.disambiguation_queue
          .filter((item) => item && item.query && isSafeLanding(item.landing_path))
          .map((item) => ({
            ...item,
            platform: item.platform || item.query,
            queue: 'disambiguation'
          }))
      : [];

    return [...visibility, ...disambiguation];
  };

  const findCandidate = (state, query) => {
    const normalizedQuery = normalize(query);
    if (!normalizedQuery) return null;

    return (
      buildCandidates(state).find(
        (item) => normalize(item.query) === normalizedQuery
      ) || null
    );
  };

  const track = (root, eventName, payload) => {
    if (!root || root.dataset.awBridgeTrack !== 'true') return;

    try {
      if (window.AWAnalytics && typeof window.AWAnalytics.track === 'function') {
        window.AWAnalytics.track(eventName, payload);
      }
    } catch (error) {
      console.warn('[AW Compatibility P2] Analytics tracking failed.', error);
    }
  };

  const render = () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.dataset.awInitialized === 'true') return;

    root.dataset.awInitialized = 'true';

    const intent = getIntent();
    if (intent === 'products' || intent === 'guides' || intent === 'atelier') return;

    const query = getQuery();
    const state = parseState();
    if (!state) return;

    const candidate = findCandidate(state, query);
    if (!candidate) return;

    const platform = String(candidate.platform || '').trim();
    const path = String(candidate.landing_path || '').trim();
    if (!platform || !isSafeLanding(path)) return;

    const title = root.querySelector('[data-aw-compatibility-bridge-title]');
    const text = root.querySelector('[data-aw-compatibility-bridge-text]');
    const link = root.querySelector('[data-aw-compatibility-bridge-link]');

    if (!title || !text || !link) return;

    title.textContent = `Compatibilité ${platform}`;

    if (candidate.queue === 'disambiguation') {
      text.textContent =
        'Cette recherche couvre plusieurs variantes exactes. Ouvrez la page Compatibility pour choisir le bon modèle avant de sélectionner une pièce ou un accessoire.';
    } else {
      text.textContent =
        'Accédez directement à la page Compatibility de cette plateforme pour vérifier les pièces, chargeurs et accessoires documentés par Assassin Workshop.';
    }

    link.href = path;
    link.textContent = `VOIR LA COMPATIBILITÉ ${platform.toUpperCase()}`;
    root.hidden = false;

    const common = {
      query,
      platform,
      landing_path: path,
      queue: candidate.queue,
      state_version: state.version || null,
      state_source: state.source || null,
      ranking_mode: 'analytics_bridge_draft'
    };

    track(root, 'search_compatibility_bridge_viewed', common);

    link.addEventListener(
      'click',
      () => track(root, 'search_compatibility_bridge_clicked', common),
      { once: true }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render, { once: true });
  } else {
    render();
  }
})();
